"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROTATIONS = void 0;
var getRotation_1 = __importDefault(require("./getRotation"));
exports.ROTATIONS = [
    {},
    {},
    { transform: "rotateY(180deg)" },
    { transform: "rotate(180deg)" },
    { transform: "rotate(180deg) rotateY(180deg)" },
    { transform: "rotate(270deg) rotateY(180deg)", transformOrigin: "top left" },
    { transform: "translateY(-100%) rotate(90deg)", transformOrigin: "bottom left" },
    {
        transform: "translateY(-100%) translateX(-100%) rotate(90deg) rotateY(180deg)",
        transformOrigin: "bottom right"
    },
    { transform: "translateX(-100%) rotate(270deg)", transformOrigin: "top right" }
];
var getNonRotatedDimensions = function (image, maxWidth, maxHeight) {
    var height = Math.min(image.height, maxHeight);
    var width = image.width * (height / image.height);
    if (width > maxWidth) {
        height *= (maxWidth / width);
        width = maxWidth;
    }
    return { left: "calc(50% - " + width / 2 + "px)", height: height, width: width };
};
var getRotatedDimensions = function (image, maxWidth, maxHeight) {
    var height = Math.min(image.height, maxHeight) * (image.height / image.width);
    var width = image.width * (height / image.height);
    if (height > maxWidth) {
        width *= (maxWidth / height);
        height = maxWidth;
    }
    return { left: "calc(50% - " + height / 2 + "px)", height: height, width: width };
};
var isMobileSafari = function (userAgent) { return (/iP(ad|od|hone)/i.test(userAgent)
    && /WebKit/i.test(userAgent)
    && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent))); };
// In mobile safari EXIF data is read and images are automatically rotated, so
// we should bail out and not attempt to read the EXIF data ourselves.
var getNormalRotation = function (image) { return (isMobileSafari(navigator.userAgent) ? Promise.resolve(1) : getRotation_1.default(image)); };
var getImagePromise = function (image, preview) { return (new Promise(function (onload, onerror) {
    Object.assign(image, { onload: onload, onerror: onerror, src: preview });
})); };
var readImage = function (image, preview, maxWidth, maxHeight) {
    var imageObj = new Image();
    var promises = [
        getNormalRotation(image),
        getImagePromise(imageObj, preview)
    ];
    return Promise.all(promises).then(function (responses) {
        var rotation = responses[0];
        var dimensions = rotation >= 5
            ? getRotatedDimensions(imageObj, maxWidth, maxHeight)
            : getNonRotatedDimensions(imageObj, maxWidth, maxHeight);
        return {
            src: imageObj.src,
            styles: __assign(__assign({}, exports.ROTATIONS[rotation]), dimensions)
        };
    });
};
exports.default = readImage;
